import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from '@giphy/react-giphy-brand'
import DescriptionInput from './input'

const HEIGHT = 85

const Wrap = styled.div`
    display: flex;
    flex-direction: row;
    height: ${HEIGHT}px;
`

const StyledDescriptionInput = styled(DescriptionInput)`
    flex-grow: 1;
    height: ${HEIGHT}px;

    textarea {
        margin-bottom: 0;
        padding: 5px;
    }
`

const SaveButton = styled(Button)`
    height: 100%;
`

type Props = {
    className: string
    value: string
    onChange?: Function
}

const EditPanelVideoDescription = ({ className, value, onChange = () => {} }: Props) => {
    const initialValue = value
    const [text, setText] = useState(initialValue)
    return (
        <div className={className}>
            <span>Video Description</span>
            <Wrap>
                <StyledDescriptionInput value={text} onChange={value => setText(value)} />
                <SaveButton disabled={text === initialValue} onClick={() => onChange(text)}>
                    Save
                </SaveButton>
            </Wrap>
        </div>
    )
}

export default EditPanelVideoDescription
